import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
import { isLoggedIn } from './lib/user'
import vSelect from 'vue-select'
import VueMeta from 'vue-meta'
import VueTippy, { TippyComponent } from "vue-tippy";
import VueRangeSlider from 'vue-range-component'
import { i18n } from './i18n'
import VueKonva from 'vue-konva';
import VueToast from 'vue-toast-notification';
import { toastSuccess, toastError } from './mixins/vue-toast-notification'
import PortalVue from 'portal-vue'
import school from './mixins/school'

Vue.use(VueKonva);

Vue.use(VueToast);

Vue.use(PortalVue)

Vue.component('v-select', vSelect)
Vue.use(VueMeta)

Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);

Vue.component('vue-range-slider', VueRangeSlider)

Vue.config.productionTip = false
Vue.use(VeeValidate, {
	events: ''
})

Vue.mixin({
	methods: {
		isLoggedIn: () => isLoggedIn(),
		toastSuccess,
		toastError
	}
})

Vue.mixin(school)

Vue.config.errorHandler = (err, vm, info) => {
	let alert = document.createElement('DIV')
	let app = document.getElementById('app')
	let close = document.createElement('DIV')

	setTimeout(() => {
		alert.classList.add('animated')
		alert.classList.add('fadeInDown')
		alert.classList.add('message-box-error')
		close.classList.add('close-message')

		alert.innerHTML = `<div class="message">${err.message}</div>`
		close.innerHTML = 'X'

		alert.appendChild(close)

		app.appendChild(alert)

		close.onclick = () => {
			alert.remove()
		}
	}, 50)

	console.error(info + ': ' + err);
}

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')
